import React, { FC, useEffect, useState } from 'react'

import { v4 as uuidV4 } from 'uuid'

import { DecorationTitle } from 'src/components/atoms'
import { AddAllowedIpButton } from 'src/components/molecules'
import { AllowedIpList } from 'src/components/organisms'

import { AllowedIpEntity, NewAllowedIpId } from 'src/types'

type Props = {
  allowedIps: AllowedIpEntity[]
  afterCrud: () => void
  className?: string
}

export const AllowedIps: FC<Props> = ({ allowedIps, afterCrud, className }) => {
  const [displayAllowedIps, setDisplayAllowedIps] =
    useState<Array<AllowedIpEntity | NewAllowedIpId>>(allowedIps)

  useEffect(() => setDisplayAllowedIps(allowedIps), [allowedIps])

  const handleAdd = () => {
    setDisplayAllowedIps([...displayAllowedIps, uuidV4()])
  }

  const handleDeleteNewItem = (newItemId: NewAllowedIpId) => {
    const updatedAllowedIps = displayAllowedIps.filter(ip => ip !== newItemId)
    setDisplayAllowedIps(updatedAllowedIps)
  }

  return (
    <div className={className}>
      <DecorationTitle>許可するIPアドレス</DecorationTitle>
      <AllowedIpList
        allowedIps={displayAllowedIps}
        afterCrud={afterCrud}
        deleteNewItem={handleDeleteNewItem}
        className="tw-mt-s0"
      />
      <AddAllowedIpButton onClick={handleAdd} className="tw-w-full tw-mt-s0" />
    </div>
  )
}
